import { Component } from '@angular/core'
// Styles loaded via src/styles/styles.less -> components/signed-page.less

@Component({
    selector: 'ca-signed',
    templateUrl: './signed.component.html',
    standalone: false
})
export class SignedComponent {}